import { UserDashboardQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { Alert } from 'react-bootstrap';

export interface Props {
  bookingWithIncompleteGuestForm: Pick<
    UserDashboardQuery['user']['bookings']['items'][number],
    'group' | 'spaces' | 'id' | 'trip'
  >;
}

export default function BookingOwnerTripFormAlertItem({
  bookingWithIncompleteGuestForm,
}: Props): JSX.Element {
  const [show, setShow] = useState(true);
  const { query } = useRouter();
  const { userID } = query;

  const fillTripForm = `Please complete your trip form for ${
    bookingWithIncompleteGuestForm.trip.title
  } (${DateTime.fromISO(bookingWithIncompleteGuestForm.group.start.utc, {
    zone: bookingWithIncompleteGuestForm.group.start.zone,
  }).toFormat('MMMM yyyy')}).`;

  const isSingleSpace = bookingWithIncompleteGuestForm.spaces.length === 1;

  const link = isSingleSpace
    ? `/me/${userID}/guestForm/${bookingWithIncompleteGuestForm.spaces[0].id}`
    : `/me/${userID}/bookings/${bookingWithIncompleteGuestForm.id}/guests`;

  return (
    <>
      {show && (
        <Alert
          key={bookingWithIncompleteGuestForm.id}
          variant="danger"
          onClose={() => setShow(false)}
          dismissible
          className="mt-3"
        >
          <Link passHref href={link} legacyBehavior>
            <Alert.Link>{fillTripForm}</Alert.Link>
          </Link>
        </Alert>
      )}
    </>
  );
}
